import { createReducer, on } from '@ngrx/store';

import { SortOrder } from '@common/utils/search-sort';
import { setLastPageStateUsers } from '@store/actions/users.actions';

export interface UsersState {
  lastPageState: LastPageStateUsers;
}

export interface LastPageStateUsers {
  searchValue: string;
  sortOrder: SortOrder;
}

export const initialStateUsers: UsersState = {
  lastPageState: {
    searchValue: '',
    sortOrder: SortOrder.Asc,
  },
};

export const usersReducer = createReducer(
  initialStateUsers,
  on(setLastPageStateUsers, (state, { newPageState }) => {
    return {
      ...state,
      lastPageState: {
        ...state.lastPageState,
        ...newPageState,
      },
    };
  }),
  // on(setStateUsersSearchValue, (state, { searchValue }) => ({ ...state, searchValue })),
  // on(setStateUsersSortOrder, (state, { sortOrder }) => ({ ...state, sortOrder })),
);
